var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 7a4.875 4.875 0 1 1-9.75 0 4.875 4.875 0 0 1 9.75 0M1 7a6 6 0 1 0 12 0A6 6 0 0 0 1 7m5.438-3.187V7c0 .188.093.364.25.47l2.25 1.5a.56.56 0 0 0 .78-.158.56.56 0 0 0-.156-.78l-2-1.332V3.813A.56.56 0 0 0 7 3.25a.56.56 0 0 0-.562.563"
  })));
};
export default SvgClock;